<template>
  <aside
    v-bind:style="{
      color: cia.color_texto_menu,
      'background-color': cia.color_fondo_menu,
    }"
    class="left-sidebar"
  >
    <div class="scroll-sidebar">
      <nav class="sidebar-nav">
        <ul
          v-bind:style="{
            color: cia.color_texto_menu,
            'background-color': cia.color_fondo_menu,
          }"
          id="sidebarnav"
        >
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            class="sidebar-item"
            id="Dashboard"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              class="sidebar-link has-arrow waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Dashboard')"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class=" fas fa-home"
              />
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.dashboard.title")}}</span
              >
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            class="sidebar-item"
            v-on:click="Expand_SubMenu('ul_catalogos', 'a_catalogos')"
            id="Catalogos"
            v-if="usuario_permisos.nomseccion1.indexOf('Catálogos') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_catalogos"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-th-list"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.catalogo.title")}}</span
              >
            </a>
            <ul
              id="ul_catalogos"
              aria-expanded="false"
              class="collapse first-level ul_expanded"
            >
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Catálogo de Empleados'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Empleados')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.empleados")}}</span>
                </a>
              </li>
              <li
                v-on:click="Expand_SubMenu('ul_asignacion', 'a_asignacion')"
                class="sidebar-item"
                v-if="usuario_permisos.nomseccion2.indexOf('Asignación') >= 0"
              >
                <a
                  id="a_asignacion"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.asignacion.title")}}</span>
                </a>
                <ul
                  id="ul_asignacion"
                  aria-expanded="false"
                  class="collapse second-level"
                >
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf(
                        'Cambiar Perfil de Usuario'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta('Cambiar_Perfil_Usuario')
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.asignacion.cambiar_perfil_usuario")}} </span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf(
                        'Analista Simulado'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('Analista_Simulado')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-left"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.asignacion.analista_simulado")}}  </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Control de Población'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Control_Poblacion')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.control_poblacion.title")}}</span>
                </a>
              </li>
              <li
                v-on:click="Expand_SubMenu('ul_datos_stps', 'a_datos_stps')"
                class="sidebar-item"
                v-if="usuario_permisos.nomseccion2.indexOf('Datos STPS') >= 0"
              >
                <a
                  id="a_datos_stps"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.datos_stps.title")}}</span>
                </a>
                <ul
                  id="ul_datos_stps"
                  aria-expanded="false"
                  class="collapse second-level"
                >
                <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf(
                        'Áreas Tematicas'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('areas_tematicas')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-left"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.datos_stps.areas_tematicas")}} </span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf(
                        'Representantes DC3'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('Representantes_DC3')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-left"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.datos_stps.representantes_dc3")}} </span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf('Plantilla DC4') >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('Plantilla_DC4')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.datos_stps.plantilla_dc4")}}</span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf(
                        'Establecimientos STPS'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta('Establecimientos_STPS')
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.datos_stps.establecimiento_stps")}}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Recursos de Capacitación'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Recursos_Capacitacion')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.recursos_capacitacion")}}</span>
                </a>
              </li>
              <li
                v-on:click="
                  Expand_SubMenu('ul_gestionar_temas', 'a_gestionar_temas')
                "
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Gestionar Temas') >= 0
                "
              >
                <a
                  id="a_gestionar_temas"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.gestion_temas.title")}}</span>
                </a>
                <ul
                  id="ul_gestionar_temas"
                  aria-expanded="false"
                  class="collapse second-level"
                >
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf('Listar Temas') >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('Listar_Temas')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-left"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.gestion_temas.listar_temas")}}</span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion3.indexOf('Grupos de Temas') >=
                      0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="ejecutar_ruta('Grupos_Temas')"
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-left"></i>
                      <span class="hide-menu">{{$t("page.menu.catalogo.gestion_temas.grupos_temas")}}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Encuestas de cursos'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Encuestas de cursos')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.encuesta_cursos")}}</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Estructura de Puestos'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Estructura_Puestos')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.catalogo.estructuras_puestos")}}</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            v-on:click="
              Expand_SubMenu('ul_plan_capacitacion', 'a_plan_capacitacion')
            "
            class="sidebar-item"
            id="Plan_Capacitacion"
            v-if="
              usuario_permisos.nomseccion1.indexOf('Plan de Capacitación') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_plan_capacitacion"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-graduation-cap"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.plan_capacitacion.title")}}</span
              >
            </a>
            <ul
              id="ul_plan_capacitacion"
              aria-expanded="false"
              class="collapse first-level ul_expanded"
              style="width: 300px !important"
            >
              <li
                v-on:click="
                  Expand_SubMenu(
                    'ul_capacitacion_institucional',
                    'a_capacitacion_institucional'
                  )
                "
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Capacitación Institucional'
                  ) >= 0
                "
              >
                <a
                  id="a_capacitacion_institucional"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.plan_capacitacion.capacitacion_institucional.title")}}</span>
                </a>
                <ul
                  id="ul_capacitacion_institucional"
                  aria-expanded="false"
                  style="left: 300px !important"
                  class="collapse second-level"
                >
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Capacitación Institucional'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Consulta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta(
                          'Capacitacion_Institucional_Consulta_Requerimientos'
                        )
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.capacitacion_institucional.consulta_requerimientos")}} </span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Capacitación Institucional'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Alta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta(
                          'Capacitacion_Institucional_Alta_Requerimientos'
                        )
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.capacitacion_institucional.alta_requerimientos")}}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                v-on:click="
                  Expand_SubMenu('ul_plan_formacion', 'a_plan_formacion')
                "
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Plan de Formación') >= 0
                "
              >
                <a
                  id="a_plan_formacion"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.title")}} </span>
                </a>
                <ul
                  id="ul_plan_formacion"
                  aria-expanded="false"
                  style="left: 300px !important"
                  class="collapse second-level"
                >
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Plan de Formación'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Consulta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta('Plan_Formacion_Consulta_Requerimientos')
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.consulta_requerimientos")}}</span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Plan de Formación'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Alta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta('Plan_Formacion_Alta_Requerimientos')
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.alta_requerimientos")}}</span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Plan de Formación'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Baja de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta('Plan_Formacion_Baja_Requerimientos')
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.baja_requerimientos")}} </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                v-on:click="
                  Expand_SubMenu(
                    'ul_capacitacion_especifica',
                    'a_capacitacion_especifica'
                  )
                "
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Capacitación Especifica'
                  ) >= 0
                "
              >
                <a
                  id="a_capacitacion_especifica"
                  class="sidebar-link has-arrow waves-effect waves-dark"
                  href="javascript:void(0)"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu">{{$t("page.menu.plan_capacitacion.capacitacion_especifica.title")}}</span>
                </a>
                <ul
                  id="ul_capacitacion_especifica"
                  aria-expanded="false"
                  style="left: 300px !important"
                  class="collapse second-level"
                >
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Capacitación Especifica'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Consulta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta(
                          'Capacitacion_Especifica_Consulta_Requerimientos'
                        )
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.consulta_requerimientos")}} </span>
                    </a>
                  </li>
                  <li
                    class="sidebar-item"
                    v-if="
                      usuario_permisos.nomseccion2.indexOf(
                        'Capacitación Especifica'
                      ) >= 0 &&
                      usuario_permisos.nomseccion3.indexOf(
                        'Alta de Requerimientos'
                      ) >= 0
                    "
                  >
                    <a
                      href=""
                      v-on:click.prevent="
                        ejecutar_ruta(
                          'Capacitacion_Especifica_Alta_Requerimientos'
                        )
                      "
                      class="sidebar-link"
                    >
                      <i class="mdi mdi-border-all"></i>
                      <span class="hide-menu">{{$t("page.menu.plan_capacitacion.plan_formacion.alta_requerimientos")}}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li
                class="sidebar-item"
                v-if="usuario_permisos.nomseccion2.indexOf('Plantas') >= 0"
              >
                <a
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Plantas_Temas')"
                  class="sidebar-link"
                >
                  <i class="mdi mdi-border-left"></i>
                  <span class="hide-menu">{{$t("page.menu.plan_capacitacion.capacitacion_planta")}}</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Historial de Capacitación General'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="
                    ejecutar_ruta('Historial_Capacitacion_General')
                  "
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu"
                    >{{$t("page.menu.plan_capacitacion.historial_general")}}</span
                  >
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Certificaciones externas'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="
                    ejecutar_ruta('certificaciones_externas')
                  "
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu"
                    >{{$t("page.menu.plan_capacitacion.certificaciones_externas")}}</span
                  >
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf(
                    'Consultar mi Plan de Capacitación'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="
                    ejecutar_ruta('Consultar_Plan_Capacitacion')
                  "
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-none"></i>
                  <span class="hide-menu"
                    >{{$t("page.menu.plan_capacitacion.consulta_plan_capacitacion")}}</span
                  >
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Simulador de Puesto') >=
                  0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Simulador_Puesto')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">Simulador de Puesto</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Temas Empleados') >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Temas_Empleados')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.plan_capacitacion.temas_empleados")}}</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            v-on:click="Expand_SubMenu('ul_cursos', 'a_cursos')"
            class="sidebar-item"
            id="Cursos"
            v-if="usuario_permisos.nomseccion1.indexOf('Cursos') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_cursos"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="far fa-calendar-alt"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.cursos.title")}}</span
              >
            </a>
            <ul
              id="ul_cursos"
              aria-expanded="false"
              class="collapse first-level ul_expanded"
            >
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Consultar Cursos') >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Grid_Cursos')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.cursos.consultar_cursos")}}</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="usuario_permisos.nomseccion2.indexOf('Calendario') >= 0"
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Calendar_Cursos')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.cursos.calendario_cursos")}}</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            class="sidebar-item mega-dropdown"
            id="Tutoria_Operativa"
            v-if="
              usuario_permisos.nomseccion1.indexOf('Tutoría Operativa') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_plan_capacitacion"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="far fa-credit-card"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.tutoria_operativa.title")}}
              </span>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            v-on:click="Expand_SubMenu('ul_indicadores', 'a_indicadores')"
            class="sidebar-item"
            id="Indicadores"
            v-if="usuario_permisos.nomseccion1.indexOf('Indicadores') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_indicadores"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-chart-area"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.indicadores.title")}}</span
              >
            </a>
            <ul
              id="ul_indicadores"
              aria-expanded="false"
              class="collapse first-level ul_expanded"
            >
              <li
                class="sidebar-item"
                v-if="usuario_permisos.nomseccion1.indexOf('Indicadores') >= 0"
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Graficas')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.indicadores.graficas")}}</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion1.indexOf('Indicadores') >= 0 &&
                  usuario_permisos.nomseccion2.indexOf(
                    'Avance de Audencia Meta'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Avance_Audencia_Meta')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.indicadores.avance_audiencia_meta")}}</span>
                </a>
              </li>
              <li
                class="sidebar-item"
                v-if="
                  usuario_permisos.nomseccion1.indexOf('Indicadores') >= 0 &&
                  usuario_permisos.nomseccion2.indexOf(
                    'Avance por Grupos de Temas'
                  ) >= 0
                "
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Avance_Grupos_Temas')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.indicadores.avance_grupo_temas")}}</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            v-on:click="
              Expand_SubMenu('ul_reportes_masivos', 'a_reportes_masivos')
            "
            class="sidebar-item"
            id="Reporte_Masivo"
            v-if="usuario_permisos.nomseccion1.indexOf('Reportes') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              id="a_reportes_masivos"
              class="sidebar-link has-arrow waves-effect waves-dark a_expanded"
              href="javascript:void(0)"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-clipboard-list"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >{{$t("page.menu.reportes.title")}}</span
              >
            </a>
            <ul
              id="ul_reportes_masivos"
              aria-expanded="false"
              class="collapse first-level ul_expanded"
            >
              <li
                v-if="
                  usuario_permisos.nomseccion2.indexOf('Reporte Masivo') >= 0
                "
                class="sidebar-item"
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Reporte_Masivo')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.reportes.reporte_masivo")}}</span>
                </a>
              </li>
              <li
                v-if="usuario_permisos.nomseccion2.indexOf('Reporteador') >= 0"
                class="sidebar-item"
              >
                <a
                  class="sidebar-link waves-effect waves-dark sidebar-link"
                  href=""
                  v-on:click.prevent="ejecutar_ruta('Reporteador')"
                  aria-expanded="false"
                >
                  <i class="mdi mdi-border-top"></i>
                  <span class="hide-menu">{{$t("page.menu.reportes.reporteador")}}</span>
                </a>
              </li>
            </ul>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            class="sidebar-item"
            id="Cargas_Masivas"
            v-if="usuario_permisos.nomseccion1.indexOf('Cargas Masivas') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              class="sidebar-link waves-effect waves-dark sidebar-link"
              href=""
              v-on:click.prevent="ejecutar_ruta('Cargas_Masivas')"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-cloud-upload-alt"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >Cargas Masivas</span
              >
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_menu,
            }"
            class="sidebar-item"
            id="Notificaciones"
            v-if="usuario_permisos.nomseccion1.indexOf('Notificaciones') >= 0"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_menu,
              }"
              class="sidebar-link waves-effect waves-dark sidebar-link"
              href=""
              v-on:click.prevent="ejecutar_ruta('Notificaciones')"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="fas fa-envelope"
              ></i>
              <span
                v-bind:style="{
                  color: cia.color_texto_menu,
                }"
                class="hide-menu"
                >Notificaciones</span
              >
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    Expand_SubMenu(ul_id, a_id) {
      var li_activa = false;
      $("#sidebarnav")
        .find(".ul_expanded")
        .each(function (i, element) {
          if ($(element).attr("id") == ul_id) {
            if ($(element).hasClass("show") === true) {
              li_activa = true;
            }
          }
        });
      $("#sidebarnav")
        .find(".a_expanded")
        .each(function (i, element) {
          $(element).attr("aria-expanded", false);
        });
      $("#sidebarnav")
        .find(".ul_expanded")
        .each(function (i, element) {
          $(element).removeClass("show");
        });
      if (!li_activa) {
        $("#" + ul_id).addClass("show");
        $("#" + a_id).attr("aria-expanded", true);
      }
    },
    ejecutar_ruta(route_name) {
      this.$router.push({ name: route_name });
      if ($("#main-wrapper").hasClass("show-sidebar")) {
        $("#main-wrapper").removeClass("show-sidebar");
        if ($("#option_abrir_sidever").hasClass("ti-menu")) {
        } else {
          $("#option_abrir_sidever").addClass("ti-menu");
        }
      }
    },
    ...mapActions(["Definir_Permisos_Del_Usuario"]),
  },
  watch: {
    usuario_permisos: function () {},
    perfiles_secciones: function () {
      this.Definir_Permisos_Del_Usuario();
    },
    usuario: function () {
      this.Definir_Permisos_Del_Usuario();
    },
  },
  computed: {
    usuario_permisos() {
      return this.$store.getters.getUsuario_Permisos;
    },
    usuario() {
      return this.$store.getters.getUsuario;
    },
    cia() {
      return this.$store.getters.getCia;
    },
    perfiles_secciones() {
      return this.$store.getters.getPerfiles_Secciones;
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/AppLms/Menu/SubHeaderOptions.vue